import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import Skeleton from '@ynap/skeleton'

const bem = new BEMHelper('OrderTracking')

const HeaderSkeleton: React.FC = () => {
    return (
        <div className={bem('headerContainer')}>
            <div className={bem('header-hero')}>
                <Skeleton className={bem('skeleton-header-title')} />
                <Skeleton className={bem('skeleton-description')} />
            </div>
            <div className={bem('header-status')}>
                <Skeleton className={bem('skeleton-title')} />
                <Skeleton className={bem('skeleton-description')} />
            </div>
        </div>
    )
}

export default HeaderSkeleton
